<template>
  <div>

      <v-dialog v-model="invoiceDialog" max-width="700px">

          <v-card>
            <v-card-title>
              <span class="headline">
                 <span style="font-weight:bold">Račun: {{ partner }}
                 </span>
              </span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                >

                  <v-row v-if="history.length > 0">
                    <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                      Povijest
                      <v-row v-for="item in history" :key="item.createdOn" dense>
                          <v-col cols="12" sm="1" class="text-xs-left" >
                            {{ item.status }}
                          </v-col>
                          <v-col cols="12" sm="3" class="text-left">
                            {{ localDate(item.createdOn) }}
                          </v-col>
                          <v-col cols="12" sm="7" class="text-left">
                            {{ item.statusText }}
                          </v-col>                   
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row v-if="eHistory.length > 0">
                    <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                      eIzvještavanje
                      <v-row v-for="item in eHistory" :key="item.createdOn" dense>
                          <v-col cols="12" sm="1" class="text-xs-left">
                            {{ item.type }}
                          </v-col>
                          <v-col cols="12" sm="3" class="text-left">
                            {{ localDate(item.createdOn) }}
                          </v-col>
                          <v-col cols="12" sm="1" class="text-left">
                            <span v-if="item.success"><v-chip color="green" label size="x-small">{{lang.loaded}}</v-chip></span>
                            <span v-if="!item.success"><v-chip color="red" label size="x-small">{{lang.notLoaded}}</v-chip></span>
                          </v-col>
                           <v-col cols="12" sm="5" class="text-left">
                            {{ item.description }}
                          </v-col>

                          <v-row v-if="item.paymentDate">
                            <v-col cols="12" sm="2" class="text-left">
                              Plaćen:{{ localDate(item.paymentDate) }}
                            </v-col>
                            <v-col cols="12" sm="3" class="text-left">
                              {{ localMoney(item.paidAmount) }}
                            </v-col>
                            <v-col cols="12" sm="1" class="text-left">
                              {{ parseInt(item.paymentType) }}
                            </v-col>
                          </v-row>

                          <v-row v-if="item.rejectionDate">
                            <v-col cols="12" sm="2" class="text-left">
                             Odbijen: {{ localDate(item.rejectionDate) }}
                            </v-col>
                            <v-col cols="12" sm="2" class="text-left">
                              {{ localMoney(item.rejectionType) }}
                            </v-col>
                             <v-col cols="12" sm="5" class="text-left">
                              {{ parseInt(item.rejectionReason) }}
                            </v-col>
                          </v-row>
                      </v-row>
                    </v-col>
                  </v-row>

                  <!-- <v-row class="pa-1">
                    <v-spacer></v-spacer>
                      <v-btn color="success"  @click="documentLoadXml" class="mr-1 pa-1">Preuzmi/Odobri
                    </v-btn>  
                  </v-row> -->
                  <v-row class="pa-1" v-if="!imaMER">
                    <v-spacer></v-spacer>
                      <v-btn color="blue" block  @click="documentLoadXml" class="mr-1 pa-1">Preuzmi XML
                    </v-btn>  
                  </v-row>
                  <v-row class="pa-1" v-if="!imaMER">
                    <v-spacer></v-spacer>
                      <v-btn color="success" block  @click="documentLoadXml2" class="mr-1 pa-1">Napravi Primku
                    </v-btn>  
                  </v-row>
                  <!-- <v-row class="pa-1">
                    <v-spacer></v-spacer>
                      <v-btn color="red"  @click="documentLoadXml" class="mr-1 pa-1">Odbij
                    </v-btn>  
                  </v-row> -->

                  <v-row class="pa-1">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeInvoiceDialog" class="mr-3 pa-0"> {{langC.Cancel}} </v-btn> 
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
 
          </v-card>
        </v-dialog>

      <v-card class="mt-2">
        <v-card-title>
          {{ documentNameLoc }}Total: <span class="title indigo--text">{{ localMoney(total) }}</span>
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>
        <v-data-table
            dense
            :headers="headers"
            :items="items"
            item-key="documentId"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="50"
            @click:row="changeInvoiceDialog"
            :mobile-breakpoint="0" 
          >

          <template v-slot:[`item.documentType`]="{ item }">
              <span>{{ localDocName(item.documentType) }}</span>
          </template>
          <template v-slot:[`item.supplierPartyNameShort`]="{ item }">
              <span class="title">{{ item.supplierPartyNameShort }}</span>
          </template>
          <template v-slot:[`item.insertedOn`]="{ item }">
              <span>{{ localFullDate(item.insertedOn) }}</span>
          </template>
          <template v-slot:[`item.issuedOn`]="{ item }">
              <span>{{ localFullDate(item.issuedOn) }}</span>
          </template>
          <template v-slot:[`item.modifiedOn`]="{ item }">
              <span>{{ localFullDate(item.modifiedOn) }}</span>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
              <span class="title indigo--text">{{ localMoney(item.amount) }}</span>
          </template>
          <template v-slot:[`item.BookID`]="{ item }">
              <span v-if="item.BookID">{{ parseInt(item.BookID) }}</span>
          </template>
          <template v-slot:[`item.inBooks`]="{ item }">
            <span v-if="item.inBooks"><v-chip color="green" label>{{lang.loaded}}</v-chip></span>
            <span v-if="!item.inBooks"><v-chip color="red" label>{{lang.notLoaded}}</v-chip></span>
          </template>

          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
        </v-data-table>
      </v-card>
    </div>
</template>

<script>
// import axios from 'axios'
import MainLedgerService from '@/services/MainLedgerService'
import MainLedgerDetailService from '@/services/MainLedgerDetailService'
import PondiService from '@/services/PondiService'
import {checkBooks } from './mainledgerHelper'
import { mapGetters } from 'vuex'
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dateFormat from '@/snippets/dateFormat'
import moneyFormat from '@/snippets/moneyFormat'
import {formatDateTime} from '@/snippets/allSnippets'

export default {
  name: 'mainledgerbooklist',
  props: ['items', 'total'],
  data () {
    return {
      documentName: '',
      documentNameLoc: '',
      locDocument: {},
      docside: 0,
      msg: '',
      bookItems: [],
      max25chars: (v) => v.length <= 25 || 'Input too long!',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [ ],
      mainledger: {},
      lang: {},
      langC: {},
      saving: false,
      bookTypeSl: null,
      bookTypeSelected: {},
      show: 0,
      invoiceDialog: false,
      selectedItem: null,
      history:[],
      eHistory:[],
      partner: '',
      imaMER: false
    }
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
      this.lang = ledgerEN
      this.langC = commEn;
    }
    if (this.$store.state.language === "HR") {
      this.lang = ledgerHR
      this.langC = commHr;
    }
    // console.log('total', this.total)
    await this.defaultInit()
    if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 2 && this.$store.state.documentSide === 2) {
      // mer moze ucitati samo ulazne racune
      this.imaMER = true
    }
  },
  methods: {
     localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    closeInvoiceDialog() {
      this.invoiceDialog = false
    },
    changeInvoiceDialog(item) {
      if (item.inBooks === true) {
        const doIt = confirm('Račun je već preuzet. Želite li ga preuzeti još jednom ?')
        if (doIt) {
          this.showInvoiceDialog(item)
        }
      }
      if (item.inBooks === false) {
        this.showInvoiceDialog(item)
      }
    },
    showInvoiceDialog(item) {      

      if (item) { 
        this.history.length = 0
        this.eHistory.length = 0
        if (item && item.statusHistory) {
          this.history = [...item.statusHistory]
        }
        if (item && item.eReportingRequests) {
          this.eHistory = [...item.eReportingRequests]
        }
        this.selectedItem = item
      
        if (this.$store.state.documentSide === 1) {this.partner = item.supplierPartyNameShort}
        if (this.$store.state.documentSide === 2) {this.partner = item.customerPartyName}
        console.log('this.$store.state.documentSide: ', this.$store.state.documentSide);
        this.invoiceDialog = !this.invoiceDialog
      }
    },
    async defaultInit() {
      this.headers.push(
          { text: this.lang.documentType, align: 'left', sortable: true, value: 'documentType'},
          { text: this.lang.amount, align: 'right', sortable: true, value: 'amount' },
          { text: this.lang.documentId, align: 'right', sortable: true, value: 'documentId' }
      )
      if (this.$store.state.documentSide === 1) {
      this.headers.push(
          { text: this.lang.supplierPartyName, align: 'left', sortable: true, value: 'supplierPartyNameShort' },
          { text: this.lang.supplierPartyVATId, align: 'left', sortable: true, value: 'supplierPartyVATId' }
      )}
      if (this.$store.state.documentSide === 2) {
      this.headers.push(
          { text: this.lang.customerPartyName, align: 'left', sortable: true, value: 'customerPartyName' },
          { text: this.lang.customerPartyVATId, align: 'left', sortable: true, value: 'customerPartyVATId' }
      )}
      this.headers.push(
          { text: this.lang.issuedOn, align: 'left', sortable: true, value: 'issuedOn' },
          { text: this.lang.insertedOn, align: 'left', sortable: true, value: 'insertedOn' },
          { text: this.lang.modifiedOn, align: 'left', sortable: true, value: 'modifiedOn' },
          
      )
      this.headers.push(
          { text: this.lang.inBooks, align: 'left', sortable: true, value: 'inBooks' },
      )
      if (this.$store.state.documentSide === 1) {
      this.headers.push(
          { text: this.lang.BookID, align: 'left', sortable: true, value: 'BookID' },
      )}
      if (this.$store.state.documentSide === 2) {
      this.headers.push(
          { text: this.lang.BookID2, align: 'left', sortable: true, value: 'BookID' },
      )}
      this.headers.push(
          { text: this.lang.idMiddleman, value: 'id' }
      )

   
    },
    async navigateTo (params) {
      this.mldetails = []
      this.$store.dispatch('setMainLedgerTotals', 0)
      this.$store.dispatch('seteditItem', 0)
      this.$store.dispatch('setretPath', 'mainledger3')
      this.$store.dispatch('setMainLedgerid', params.id)
      const locDocument = await MainLedgerService.show(params.id)
      this.mainledger = locDocument.data.mainLedger
      this.mldetails = (await MainLedgerDetailService.index(params.id)).data.mainledgerDetails
      await this.$store.dispatch('setMainLedgerActiv', this.mainledger ? this.mainledger : {})
      await this.$store.dispatch('setMainLedgerItems', this.mldetails ? this.mldetails : [])
      this.bookTypeSelected.text = this.mainledger.BookName
      this.bookTypeSelected.value = parseInt(this.mainledger.BookTypeID)
      await this.$store.dispatch('setbookTypeSelected', this.bookTypeSelected)
      this.$router.push({
        name: 'mainledgerview'
      })
    },
    documentLoadXml() {      
       this.$emit("myEvent", this.selectedItem.id)
    },
    documentLoadXml2() {      
       this.$emit("myEvent2", this.selectedItem.id)
    },
    async mainledgerDetails (mainledgerid) {
      try {
        this.$store.dispatch('setMainLedgerid', mainledgerid)
        const locDocument = await MainLedgerService.show(this.$store.state.mainledgerid)
        this.mainledger = locDocument.data.mainLedger
        await this.$store.dispatch('setMainLedgerActiv', this.mainledger)
        this.$store.dispatch('seteditItem', 1)
        this.$store.dispatch('setretPath', 'mainledger3')
        await this.$router.push({
          name: 'mainledgerdetail'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    localDate(dateToFormat) {
       return dateFormat(dateToFormat)
    },
    localFullDate(fullD){
        return formatDateTime(fullD)
    },
    localDocName(documentType) {
      return (documentType === 'Invoice' ? 'Račun' : 'Odobrenje')
    },
    async initAgain () {

    }
  },
  computed: {
    ...mapGetters({
      newTikTok: 'NeedTikTok'
    })
  },
  watch: {
    'newTikTok' () {
      console.log('gledamTikTok', this.newTikTok)
      this.invoiceDialog = false
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
